import tinycolor from 'tinycolor2';

/**
 * Determine the text color based on the background color
 * 
 * @param backgroundColor 
 * @param idealTextColor 
 * 
 * @returns {string} The ideal text color
 */
export const determineTextColor = (backgroundColor: string, idealTextColor: string): string => {
    if (tinycolor.readability(idealTextColor, backgroundColor) >= 3) {
        return idealTextColor;
    }

    return tinycolor
        .mostReadable(backgroundColor, ['#000', '#fff'])
        .toHexString();
}